import React from "react";
import { NavLink } from "react-router-dom";

class ValveSidebar extends React.Component {
  render() {
    return (
      <>
        <div className="col-lg-4 col-md-12 rightSidebar">
          <div className="all_services service-side-btn m-b30 site-bg-secondry p-a20 text-white">
            <h2 className="wt-title">Suppliers</h2>
            <ul>
              <li>
                <NavLink to={"/products/valves/burkert"}>Burkert</NavLink>
              </li>
              <li>
                <NavLink to={"/products/valves/hayward"}>
                  Hayward Industrial
                </NavLink>
              </li>
              <li>
                <NavLink to={"/products/valves/hays"}>
                  Hays Fluid Controls
                </NavLink>
              </li>
              <li>
                <NavLink to={"/products/valves/primary-fluid"}>
                  Primary Fluid Systems
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </>
    );
  }
}

export default ValveSidebar;
